import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";

export default function DeleteTrainerModal({ show, onHide, onDelete }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      contentClassName="p-0"
    >
      <Modal.Body
        style={{
          textAlign: "center",
          padding: "30px 20px",
          borderRadius: "12px",
        }}
      >
        {/* ICON */}
        <div
          style={{
            width: "70px",
            height: "70px",
            background: "#fde2e2",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 15px",
            color: "#e11d48",
          }}
        >
          <FiTrash2 size={28} />
        </div>

        {/* TITLE */}
        <h4
          style={{
            fontWeight: "600",
            marginBottom: "8px",
            color: "#1f2937",
          }}
        >
          Confirm Delete
        </h4>

        {/* TEXT */}
        <p
          style={{
            color: "#6b7280",
            fontSize: "14px",
            marginBottom: "20px",
            lineHeight: "1.5",
          }}
        >
          You want to delete all the marked items, this cant be undone once you
          delete.
        </p>

        {/* BUTTONS */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          <Button
            onClick={onHide}
            style={{
              background: "#f1f3f5",
              border: "none",
              padding: "8px 18px",
              borderRadius: "8px",
              color: "#374151",
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={onDelete}
            style={{
              background: "#ef4444",
              border: "none",
              padding: "8px 18px",
              borderRadius: "8px",
              color: "#fff",
            }}
          >
            Yes, Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}